import { r as registerTranslation, t as translation, a as translation$1, _ as __decorate, b as __metadata, F as FormControl, c as FormControlController } from '../en-Bj2vADBP.js';
import { css, html, nothing } from 'lit';
import { query, queryAssignedElements, property, state, customElement } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { when } from 'lit/directives/when.js';
import { f as formatSize } from '../utils-xlxkOHqp.js';
import 'lit/directive.js';

var styles = css`@charset "UTF-8";
*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: hsla(0, 0%, 0%, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

p {
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: var(--bsi-spacing-s);
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: var(--bsi-spacing-l);
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: var(--bsi-font-weight-strong);
}

dd {
  margin-bottom: var(--bsi-spacing-xxs);
  margin-left: 0;
}

blockquote {
  margin: 0 0 var(--bsi-spacing-s);
}

sub,
sup {
  position: relative;
  font-size: var(--bsi-font-size-1);
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--bsi-color-link);
  text-decoration: underline;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;
}
a:hover {
  color: var(--bsi-color-link-hover);
  cursor: pointer;
}

pre,
code,
kbd,
samp {
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
  overflow: auto;
}
pre code {
  word-break: normal;
}

a > code {
  color: inherit;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: hsl(210, 17%, 44%);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.btn {
  --bsi-btn-background: transparent;
  --bsi-btn-border-color: transparent;
  --bsi-btn-border-radius: var(--bsi-radius-smooth);
  --bsi-btn-border-size: 0;
  --bsi-btn-disabled-opacity: 0.5;
  --bsi-btn-font-family: var(--bsi-font-sans);
  --bsi-btn-font-size: var(--bsi-label-font-size);
  --bsi-btn-font-weight: var(--bsi-font-weight-solid);
  --bsi-btn-line-height: var(--bsi-font-leading-3);
  --bsi-btn-outline-border-color: transparent;
  --bsi-btn-outline-border-size: 2px;
  --bsi-btn-padding-x: var(--bsi-spacing-s);
  --bsi-btn-padding-y: var(--bsi-spacing-xs);
  --bsi-btn-text-color: var(--bsi-color-text-primary);
}

/* stylelint-disable-next-line no-duplicate-selectors */
.btn {
  display: inline-block;
  padding: var(--bsi-btn-padding-y) var(--bsi-btn-padding-x);
  border: var(--bsi-btn-border-width) solid var(--bsi-btn-border-color);
  border-radius: var(--bsi-btn-border-radius);
  background: var(--bsi-btn-background);
  box-shadow: var(--bsi-btn-box-shadow, none);
  color: var(--bsi-btn-text-color);
  font-family: var(--bsi-btn-font-family);
  font-size: var(--bsi-btn-font-size);
  font-weight: var(--bsi-btn-font-weight);
  line-height: var(--bsi-btn-line-height);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  white-space: initial;
  width: auto;
  transition: all var(--bsi-transition-instant) ease-in-out;
  user-select: none;
}
.btn:hover {
  color: var(--bsi-btn-text-color);
}
.btn:disabled, .btn.disabled {
  opacity: var(--bsi-btn-disabled-opacity);
  cursor: not-allowed;
  pointer-events: none;
}
.btn:focus-visible {
  border-color: var(--bsi-btn-hover-border-color);
  outline: 0;
}
.btn-check:focus-visible + .btn {
  border-color: var(--bsi-btn-hover-border-color);
  outline: 0;
}

.btn-link {
  --bsi-btn-background: transparent;
  --bsi-btn-border-color: transparent;
  text-decoration: underline;
}
.btn-link:hover {
  color: var(--bsi-color-link-hover);
}

.btn-xs {
  --bsi-btn-padding-x: var(--bsi-spacing-xs);
  --bsi-btn-padding-y: var(--bsi-spacing-xs);
  --bsi-btn-font-size: var(--bsi-label-font-size-s);
  --bsi-btn-line-height: var(--bsi-font-leading-1);
  --bsi-rounded-icon-size: 20px;
}

.btn-lg {
  --bsi-btn-padding-x: var(--bsi-spacing-m);
  --bsi-btn-padding-y: var(--bsi-spacing-s);
  --bsi-btn-font-size: var(--bsi-label-font-size-l);
  --bsi-btn-line-height: var(--bsi-font-leading-5);
}

.btn-progress {
  position: relative;
}

.btn-icon {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--bsi-icon-spacing);
}

.btn-full {
  align-self: stretch;
  width: inherit;
  border: none;
  box-shadow: none;
}
@media (min-width: 992px) {
  .btn-full {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 0;
  }
}

.btn:disabled:hover,
.btn.disabled:hover {
  cursor: not-allowed;
}

.btn-primary,
a.btn-primary {
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
  --bsi-btn-background: var(--bsi-color-background-primary);
}
.btn-primary:hover,
a.btn-primary:hover {
  --bsi-btn-background: var(--bsi-color-background-primary-hover);
}
.btn-primary:active,
a.btn-primary:active {
  --bsi-btn-background: var(--bsi-color-background-primary-active);
}
.btn-primary.btn-progress,
a.btn-primary.btn-progress {
  border-color: hsl(210, 76%, 67%);
  opacity: 1;
  background-color: hsl(210, 76%, 67%);
}

.btn-secondary,
a.btn-secondary {
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
  --bsi-btn-background: var(--bsi-color-background-secondary);
}
.btn-secondary:hover,
a.btn-secondary:hover {
  --bsi-btn-background: var(--bsi-color-background-secondary-hover);
}
.btn-secondary:active,
a.btn-secondary:active {
  --bsi-btn-background: var(--bsi-color-background-secondary-active);
}
.btn-secondary:disabled.btn-progress, .btn-secondary.disabled.btn-progress,
a.btn-secondary:disabled.btn-progress,
a.btn-secondary.disabled.btn-progress {
  border-color: hsl(210, 12%, 52%);
  opacity: 1;
  background-color: hsl(210, 12%, 52%);
}

.btn-success,
a.btn-success {
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
  --bsi-btn-background: var(--bsi-color-background-success);
}
.btn-success:hover,
a.btn-success:hover {
  --bsi-btn-background: var(--bsi-color-background-success-hover);
}
.btn-success:active,
a.btn-success:active {
  --bsi-btn-background: var(--bsi-color-background-success-active);
}

.btn-warning,
a.btn-warning {
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
  --bsi-btn-background: var(--bsi-color-background-warning);
}
.btn-warning:hover,
a.btn-warning:hover {
  --bsi-btn-background: var(--bsi-color-background-warning-hover);
}
.btn-warning:active,
a.btn-warning:active {
  --bsi-btn-background: var(--bsi-color-background-warning-active);
}

.btn-danger,
a.btn-danger {
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
  --bsi-btn-background: var(--bsi-color-background-danger);
}
.btn-danger:hover,
a.btn-danger:hover {
  --bsi-btn-background: var(--bsi-color-background-danger-hover);
}
.btn-danger:active,
a.btn-danger:active {
  --bsi-btn-background: var(--bsi-color-background-danger-active);
}

.btn[class*=btn-outline-] {
  --bsi-btn-box-shadow: inset 0 0 0 var(--bsi-btn-outline-border-size) var(--bsi-btn-outline-border-color);
}

.btn-outline-primary,
a.btn-outline-primary {
  --bsi-btn-outline-border-color: var(--bsi-color-border-primary);
  --bsi-btn-text-color: var(--bsi-color-text-primary);
}
.btn-outline-primary:hover,
a.btn-outline-primary:hover {
  --bsi-btn-outline-border-color: color-mix(in srgb, var(--bsi-color-border-primary-hover) 70%, black);
  --bsi-btn-text-color: var(--bsi-color-link-hover);
}
.btn-outline-primary:active,
a.btn-outline-primary:active {
  --bsi-btn-outline-border-color: var(--bsi-color-border-primary-active);
  --bsi-btn-text-color: var(--bsi-color-link-active);
}
.btn-outline-secondary,
a.btn-outline-secondary {
  --bsi-btn-outline-border-color: var(--bsi-color-border-secondary);
  --bsi-btn-text-color: var(--bsi-color-text-secondary);
}
.btn-outline-secondary:hover,
a.btn-outline-secondary:hover {
  --bsi-btn-outline-border-color: var(--bsi-color-border-secondary-hover);
  --bsi-btn-text-color: var(--bsi-color-link-secondary-hover);
}
.btn-outline-secondary:active,
a.btn-outline-secondary:active {
  --bsi-btn-outline-border-color: var(--bsi-color-border-secondary-active);
  --bsi-btn-text-color: var(--bsi-color-link-secondary-active);
}
.btn-outline-success,
a.btn-outline-success {
  --bsi-btn-outline-border-color: var(--bsi-color-border-success);
  --bsi-btn-text-color: var(--bsi-color-text-success);
}
.btn-outline-success:hover,
a.btn-outline-success:hover {
  /* aumenta contrasto scurendo il bordo rispetto al token base */
  --bsi-btn-outline-border-color: color-mix(in srgb, var(--bsi-color-border-success-hover) 70%, black);
  --bsi-btn-text-color: var(--bsi-color-text-success-hover);
}
.btn-outline-success:active,
a.btn-outline-success:active {
  --bsi-btn-outline-border-color: var(--bsi-color-border-success-active);
  --bsi-btn-text-color: var(--bsi-color-text-success-active);
}
.btn-outline-warning,
a.btn-outline-warning {
  --bsi-btn-outline-border-color: var(--bsi-color-border-warning);
  --bsi-btn-text-color: var(--bsi-color-text-warning);
}
.btn-outline-warning:hover,
a.btn-outline-warning:hover {
  --bsi-btn-outline-border-color: color-mix(in srgb, var(--bsi-color-border-warning-hover) 70%, black);
  --bsi-btn-text-color: var(--bsi-color-text-warning-hover);
}
.btn-outline-warning:active,
a.btn-outline-warning:active {
  --bsi-btn-outline-border-color: var(--bsi-color-border-warning-active);
  --bsi-btn-text-color: var(--bsi-color-text-warning-active);
}
.btn-outline-danger,
a.btn-outline-danger {
  --bsi-btn-outline-border-color: var(--bsi-color-border-danger);
  --bsi-btn-text-color: var(--bsi-color-text-danger);
}
.btn-outline-danger:hover,
a.btn-outline-danger:hover {
  --bsi-btn-outline-border-color: color-mix(in srgb, var(--bsi-color-border-danger-hover) 70%, black);
  --bsi-btn-text-color: var(--bsi-color-text-danger-hover);
}
.btn-outline-danger:active,
a.btn-outline-danger:active {
  --bsi-btn-outline-border-color: var(--bsi-color-border-danger-active);
  --bsi-btn-text-color: var(--bsi-color-text-danger-active);
}

.bg-dark .btn-link {
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
}
.bg-dark a.btn-primary,
.bg-dark .btn-primary {
  --bsi-btn-text-color: var(--bsi-color-text-primary);
  --bsi-btn-background: var(--bsi-color-background-inverse);
}
.bg-dark a.btn-primary:hover,
.bg-dark .btn-primary:hover {
  --bsi-btn-background: color-mix(in srgb, var(--bsi-color-background-inverse) 85%, black);
}
.bg-dark a.btn-primary:active,
.bg-dark .btn-primary:active {
  --bsi-btn-background: color-mix(in srgb, var(--bsi-color-background-inverse) 80%, black);
}
.bg-dark a.btn-secondary,
.bg-dark .btn-secondary {
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
  --bsi-btn-background: var(--bsi-color-background-secondary);
}
.bg-dark a.btn-secondary:hover, .bg-dark a.btn-secondary:active,
.bg-dark .btn-secondary:hover,
.bg-dark .btn-secondary:active {
  --bsi-btn-background: color-mix(in srgb, var(--bsi-color-background-secondary) 85%, black);
}
.bg-dark .btn-outline-primary,
.bg-dark a.btn-outline-primary {
  --bsi-btn-outline-border-color: var(--bsi-color-border-inverse);
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
}
.bg-dark .btn-outline-primary:hover,
.bg-dark a.btn-outline-primary:hover {
  --bsi-btn-boxshadow-color-darken: color-mix(in srgb, var(--bsi-color-border-inverse) 80%, black);
  --bsi-btn-boxshadow-color-desaturated: color-mix(in srgb, var(--bsi-btn-boxshadow-color-darken) 80%, gray);
  --bsi-btn-outline-border-color: var(--bsi-btn-boxshadow-color-desaturated);
}
.bg-dark .btn-outline-secondary,
.bg-dark a.btn-outline-secondary {
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
}
.bg-dark .btn-outline-secondary:hover, .bg-dark .btn-outline-secondary:active,
.bg-dark a.btn-outline-secondary:hover,
.bg-dark a.btn-outline-secondary:active {
  --bsi-btn-boxshadow-color-darken: color-mix(in srgb, var(--bsi-color-background-secondary) 80%, black);
  --bsi-btn-boxshadow-color-desaturated: color-mix(in srgb, var(--bsi-btn-boxshadow-color-darken) 80%, gray);
  --bsi-btn-outline-border-color: var(--bsi-btn-boxshadow-color-desaturated);
}

.btn-close {
  position: relative;
  box-sizing: content-box;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border: 0;
  background-color: transparent;
}
.btn-close .icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  fill: var(--bsi-icon-secondary);
}
.btn-close .icon:hover {
  fill: var(--bsi-icon-default);
  text-decoration: none;
}
.btn-close:focus {
  opacity: 1;
}
.btn-close:disabled, .btn-close.disabled {
  opacity: var(--bsi-btn-disabled-opacity);
  pointer-events: none;
  user-select: none;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

:root {
  --bsi-form-control-height: 2.5rem;
  --bsi-form-control-spacing: var(--bsi-spacing-xxs);
  --bsi-form-control-background-color: var(--bsi-color-background-inverse);
  --bsi-form-control-border-color: var(--bsi-color-border-secondary);
  --bsi-form-control-border-radius: var(--bsi-radius-smooth);
  --bsi-form-control-placeholder-color: var(--bsi-color-text-muted);
  --bsi-form-control-label-color: var(--bsi-color-text-base);
  --bsi-form-control-text-color: var(--bsi-color-text-secondary);
  --bsi-form-control-font-size: var(--bsi-body-font-size);
  --bsi-form-group-spacing-y: var(--bsi-spacing-m);
  --bsi-form-checkbox-border-color: var(--bsi-color-border-secondary);
  --bsi-form-checkbox-border-radius: var(--bsi-radius-smooth);
  --bsi-form-checked-color: var(--bsi-color-background-primary);
}

input[readonly],
textarea[readonly],
select[readonly] {
  --bsi-form-control-border-color: var(--bsi-color-border-subtle);
  --bsi-form-control-background-color: var(--bsi-color-background-muted);
  cursor: not-allowed;
}

input,
textarea,
select {
  display: block;
  width: 100%;
  padding: var(--bsi-form-control-spacing);
  border: 1px solid var(--bsi-form-control-border-color);
  border-radius: var(--bsi-form-control-border-radius);
  background-color: var(--bsi-form-control-background-color);
  color: var(--bsi-form-control-text-color);
  font-size: var(--bsi-form-control-font-size);
}
input.disabled, input:disabled,
textarea.disabled,
textarea:disabled,
select.disabled,
select:disabled {
  border-color: var(--bsi-color-border-disabled);
  opacity: 1;
  background-color: var(--bsi-color-background-disabled);
  color: var(--bsi-color-text-disabled);
}

/* stylelint-disable-next-line no-duplicate-selectors */
input:focus,
textarea:focus {
  outline: 3px solid transparent;
  outline-offset: 3px;
  box-shadow: 0 0 0 2px var(--bsi-color-border-inverse), 0 0 0 5px var(--bsi-color-outline-focus) !important;
}

input::file-selector-button {
  margin: -0.375rem -0.75rem;
  padding: 0.375rem 0.75rem;
  border-width: 0;
  border-style: solid;
  border-radius: 0;
  border-color: inherit;
  color: hsl(0, 0%, 10%);
  pointer-events: none;
  margin-inline-end: 0.75rem;
  border-inline-end-width: 0;
  background-color: hsl(0, 0%, 100%);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  input::file-selector-button {
    transition: none;
  }
}
input:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: rgb(242.25, 242.25, 242.25);
}
input[type=file] {
  overflow: hidden;
}
input[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
input::-webkit-date-and-time-value {
  height: 1.5em;
}

select {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='hsl%280, 0%, 32%%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right var(--bsi-form-control-spacing) center;
  background-size: 16px 12px;
  appearance: none;
}
select:focus {
  border-color: hsl(210, 17%, 44%);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(0, 102, 204, 0.25);
}
select[multiple], select[size]:not([size="1"]) {
  padding-right: 0.75rem;
}
select:disabled {
  background-color: hsl(0, 0%, 90%);
}
select:disabled:hover {
  cursor: not-allowed;
}
select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 hsl(0, 0%, 10%);
}
select option {
  font-weight: normal;
}
select {
  /* stylelint-disable-next-line no-duplicate-selectors */ /* TO DO check these styles */
}
select:disabled {
  opacity: 1;
  background-color: hsl(210, 3%, 85%);
}

textarea {
  height: auto;
  font-size: var(--bsi-body-font-size);
  line-height: 1.5;
}

label {
  display: inline-block;
  width: auto;
  max-width: 100%;
  margin-bottom: var(--bsi-spacing-xxs);
  color: var(--bsi-form-control-label-color);
  font-size: var(--bsi-label-font-size-s);
  font-weight: var(--bsi-font-weight-solid);
  line-height: var(--bsi-label-leading);
}

/* stylelint-disable-next-line no-duplicate-selectors */
input,
textarea {
  outline: 0;
  box-shadow: none;
  transition: none;
  appearance: none;
}

input[type=date],
input[type=datetime-local],
input[type=time] {
  display: flex;
}

fieldset legend {
  margin-bottom: var(--bsi-spacing-s);
  padding: 0 var(--bsi-form-input-spacing-x);
  background-color: transparent;
  color: var(--bsi-form-control-text-color);
  font-size: var(--bsi-label-font-size-s);
  font-weight: var(--bsi-font-weight-solid);
}

::placeholder {
  color: var(--bsi-form-control-placeholder-color);
}

input::-webkit-datetime-edit {
  background-color: var(--bsi-color-background-primary-lighter);
  color: var(--bsi-form-contro-text-color);
}

.form-group {
  position: relative;
  margin-bottom: var(--bsi-form-group-spacing-y);
}
.form-group label.input-symbol-label:not(.active) {
  left: 2.25rem;
}
.form-group small.form-text {
  margin: 0;
  font-size: 0.875rem;
}
.form-group input[type=time] ~ label {
  font-size: 0.875rem;
}

.form-text {
  margin: var(--bsi-spacing-xxs) 0;
  color: var(--bsi-color-text-secondary);
}

.form-group.active .form-file-name {
  padding-bottom: 1.95rem;
}

.warning-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  color: var(--bsi-color-text-warning);
  font-size: 0.75rem;
}

.valid-feedback,
.invalid-feedback,
.warning-feedback {
  margin-left: 0.5rem;
}

.input-group .input-group-text .btn {
  border-radius: var(--bsi-form-control-border-radius) 0 0 var(--bsi-form-control-border-radius);
}
.input-group .input-group-append {
  margin-left: 0;
}
.input-group .input-group-append .btn {
  height: 100%;
  padding-top: 0;
  padding-bottom: 0;
  border-bottom: 1px solid hsl(210, 17%, 44%);
  border-radius: 0 var(--bsi-form-control-border-radius) var(--bsi-form-control-border-radius) 0;
}

.form-check {
  position: relative;
}
.form-check + .form-check {
  margin-top: var(--bsi-spacing-s);
}
.form-check [type=checkbox],
.form-check [type=radio] {
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  margin-top: 0;
  margin-left: 0;
  opacity: 0;
}
.form-check [type=checkbox] + label,
.form-check [type=radio] + label {
  position: relative;
  margin-bottom: 0;
  padding-left: 28px;
  font-size: var(--bsi-label-font-size);
  font-weight: var(--bsi-font-weight-solid);
  cursor: pointer;
  user-select: none;
}
@media (min-width: 576px) {
  .form-check [type=checkbox] + label,
  .form-check [type=radio] + label {
    font-size: var(--bsi-label-font-size-l);
  }
}
.form-check [type=checkbox]:focus + label,
.form-check [type=radio]:focus + label {
  border-color: hsl(0, 0%, 0%) !important;
  box-shadow: 0 0 0 2px var(--bsi-color-border-inverse), 0 0 0 5px var(--bsi-color-outline-focus) !important;
  outline: 3px solid transparent !important;
  outline-offset: 3px !important;
}
.form-check [type=checkbox]:focus[data-focus-mouse=true] + label,
.form-check [type=radio]:focus[data-focus-mouse=true] + label {
  border-color: inherit !important;
  box-shadow: none !important;
  outline: none !important;
}
.form-check input[type=checkbox] + label::after,
.form-check input[type=checkbox] + label::before {
  position: absolute;
  left: 0;
  z-index: 1;
  content: "";
  border-width: 2px;
  border-style: solid;
  transition: all var(--bsi-transition-instant) ease-out;
}
.form-check input[type=checkbox] + label::after {
  top: 0;
  width: 20px;
  height: 20px;
  border-radius: var(--bsi-form-control-border-radius);
}
.form-check input[type=checkbox]:checked + label::before {
  top: 3px;
  left: 3px;
  width: 6px;
  height: 12px;
  border-width: 2px;
  border-style: solid;
  border-color: transparent var(--bsi-color-border-inverse) var(--bsi-color-border-inverse) transparent;
  opacity: 1;
  transform: rotate(40deg);
  transform-origin: 100% 100%;
  backface-visibility: hidden;
}
.form-check input[type=checkbox]:checked + label::after {
  z-index: 0;
  border-color: var(--bsi-form-checked-color);
  background-color: var(--bsi-form-checked-color);
}
.form-check input[type=checkbox]:not(:checked) + label::after {
  z-index: 0;
  border-color: var(--bsi-form-checkbox-border-color);
  background-color: transparent;
}
.form-check input[type=checkbox]:not(:checked) + label::before {
  top: 10px;
  left: 6px;
  width: 0;
  height: 0;
  border-color: transparent;
}
.form-check input[type=checkbox] + label:hover::after {
  border-color: var(--bsi-color-border-secondary-hover);
}
.form-check input[type=checkbox]:disabled + label {
  opacity: 1;
  cursor: not-allowed;
}
.form-check input[type=checkbox]:disabled:not(:checked) + label::after {
  border-color: var(--bsi-color-border-disabled);
  background-color: transparent;
}
.form-check input[type=checkbox]:disabled:checked + label::after {
  border-color: var(--bsi-color-border-disabled);
  background-color: var(--bsi-color-border-disabled);
}
.form-check input[type=radio] + label::after, .form-check input[type=radio] + label::before {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  content: "";
  width: 20px;
  height: 20px;
  border-width: 2px;
  border-style: solid;
  border-radius: var(--bsi-radius-rounded);
  transition: all var(--bsi-transition-instant) ease-out;
}
.form-check input[type=radio]:not(:checked) + label::after, .form-check input[type=radio]:not(:checked) + label::before {
  border-color: var(--bsi-form-checkbox-border-color);
}
.form-check input[type=radio]:not(:checked) + label:after {
  z-index: -1;
  transform: scale(0);
}
.form-check input[type=radio]:checked + label::after {
  z-index: 0;
  border-color: var(--bsi-form-checked-color);
  background-color: var(--bsi-form-checked-color);
  transform: scale(0.64);
}
.form-check input[type=radio]:checked + label::before {
  border-color: var(--bsi-form-checked-color);
}
.form-check input[type=radio] + label:hover::before {
  border-color: var(--bsi-color-border-secondary-hover);
}
.form-check input[type=radio]:disabled + label {
  cursor: not-allowed;
}
.form-check input[type=radio]:disabled:not(:checked) + label::after, .form-check input[type=radio]:disabled:not(:checked) + label::before {
  border-color: var(--bsi-color-border-disabled);
}
.form-check input[type=radio]:disabled:checked + label::after {
  border-color: var(--bsi-color-border-disabled);
  background-color: var(--bsi-color-border-disabled);
}
.form-check input[type=radio]:disabled:checked + label::before {
  border-color: var(--bsi-color-border-disabled);
}
.form-check .form-text {
  display: block;
  margin-bottom: 0.5rem;
  padding-right: 3.25rem;
}
.form-check.form-check-group {
  margin-bottom: 1rem;
  padding: 0 0 1rem 0;
  box-shadow: inset 0 -1px 0 0 rgba(1, 1, 1, 0.1);
}
.form-check.form-check-group input[type=checkbox] + label,
.form-check.form-check-group input[type=radio] + label {
  position: static;
  padding-right: 3.25rem;
  padding-left: 0;
}
.form-check.form-check-group input[type=checkbox] + label::after, .form-check.form-check-group input[type=checkbox] + label::before,
.form-check.form-check-group input[type=radio] + label::after,
.form-check.form-check-group input[type=radio] + label::before {
  right: 0;
  left: auto;
}
.form-check.form-check-group input[type=checkbox]:checked + label::before {
  right: 11px;
}
.form-check.form-check-group input[type=radio]:checked + label::before {
  right: 0;
}
.form-check.form-check-group input.semi-checked:not(:checked) + label::before {
  right: 4px;
  left: auto;
}
.form-check input.semi-checked:not(:checked) + label::before {
  top: 12px;
  left: 4px;
  width: 12px;
  height: 2px;
  border-width: 0;
  border-style: none;
  border-color: transparent;
  opacity: 1;
  background: var(--bsi-color-background-inverse);
  transform: none;
  backface-visibility: hidden;
}
.form-check input.semi-checked:not(:checked) + label::after {
  z-index: 0;
  border-color: var(--bsi-form-checked-color);
  background-color: var(--bsi-form-checked-color);
}

.form-check-inline {
  display: inline-block;
}
.form-check-inline:not(:last-child) {
  margin-right: var(--bsi-spacing-m);
}

@media (prefers-reduced-motion: reduce) {
  fieldset legend,
  .form-group label,
  textarea,
  .form-check [type=checkbox],
  .form-check [type=radio],
  .form-check [type=checkbox] + label::after,
  .form-check [type=checkbox] + label::before,
  .form-check [type=radio] + label::after,
  .form-check [type=radio] + label::before,
  .toggles label input[type=checkbox] + .lever::before,
  .toggles label input[type=checkbox] + .lever::after {
    transition: none !important;
  }
}
.form-control-plaintext {
  border: 0;
  --bsi-form-control-border-color: transparent;
  --bsi-form-control-border-radius: 0;
  --bsi-form-control-background-color: transparent;
  --bsi-form-control-spacing: 0;
}
.form-control-plaintext:focus {
  outline: 0;
  box-shadow: none !important;
}
.form-control-plaintext + label {
  cursor: text;
}

.form-control {
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 45px 20px;
}
.form-control:disabled {
  cursor: not-allowed;
  background: var(--bsi-color-background-disabled);
  border: 0;
  color: var(--bsi-color-text-disabled);
}

.form-control-sm {
  --bsi-form-control-spacing: var(--bsi-spacing-xxs) var(--bsi-spacing-3xs);
  --bsi-form-control-font-size: var(--bsi-label-font-size);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  --bsi-form-control-font-size: var(--bsi-lead-font-size);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: 2.5rem;
  border: 1px solid hsl(210, 17%, 44%);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem);
}

.form-control-color {
  width: 3rem;
  height: 2.5rem;
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0;
}
.form-control-color::-webkit-color-swatch {
  border-radius: 0;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem);
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem);
}

.upload,
.upload-avatar {
  position: absolute;
  z-index: -1;
  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  opacity: 0;
}

.upload[type=file] + label {
  display: inline-block;
  margin-bottom: 0;
  max-width: 80%;
  padding: var(--bsi-spacing-xs) var(--bsi-spacing-m);
  overflow: hidden;
  border-radius: var(--bsi-form-control-border-radius);
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
  font-size: 1rem;
  font-weight: 700;
  transition: background-color var(--bsi-transition-instant);
  cursor: pointer;
}
.upload[type=file] + label:hover {
  background-color: var(--bsi-color-background-primary-hover);
}
.upload[type=file] + label svg {
  margin-right: var(--bsi-spacing-xxs);
  fill: var(--bsi-icon-inverse);
}

.upload-pictures-wall {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}
.upload-pictures-wall > li {
  margin-right: var(--bsi-spacing-xxs);
  margin-bottom: var(--bsi-spacing-xxs);
  list-style-type: none;
}
.upload-pictures-wall > li:last-child {
  margin-right: 0;
}
.upload-pictures-wall .upload[type=file] + label {
  display: table-cell;
  width: 128px;
  height: 128px;
  padding: 0;
  border: 2px dashed var(--bsi-color-border-primary);
  border-radius: 0;
  background-color: var(--bsi-color-border-primary-lighter);
  color: var(--bsi-color-text-primary);
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  transition: border-color var(--bsi-transition-instant);
}
.upload-pictures-wall .upload[type=file] + label .icon {
  display: block;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  margin: 0 auto;
  fill: var(--bsi-icon-primary);
}
.upload-pictures-wall .upload[type=file] + label:hover {
  border: 2px dashed var(--bsi-color-border-primary-hover);
}
.upload-pictures-wall .upload-image {
  flex-shrink: 0;
  width: 128px;
  height: 128px;
}
.upload-pictures-wall .upload-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-file-list {
  margin-top: 5px;
  padding: 0;
}
.upload-file-list.upload-file-list-image .progress {
  left: 52px;
}
.upload-file-list .upload-file {
  position: relative;
  display: flex;
  align-items: center;
  max-width: 375px;
  margin-bottom: var(--bsi-spacing-s);
  list-style-type: none;
}
.upload-file-list .upload-file.uploading .icon {
  fill: var(--bsi-icon-secondary);
}
.upload-file-list .upload-file.uploading p {
  color: var(--bsi-color-text-secondary);
}
.upload-file-list .upload-file.success svg {
  fill: var(--bsi-icon-success);
}
.upload-file-list .upload-file.success p {
  color: var(--bsi-color-text-success);
}
.upload-file-list .upload-file.success p .upload-file-weight {
  display: inline-block;
}
.upload-file-list .upload-file.error svg {
  fill: var(--bsi-icon-danger);
}
.upload-file-list .upload-file.error p {
  color: var(--bsi-color-text-danger);
}
.upload-file-list .upload-file svg {
  flex-shrink: 0;
}
.upload-file-list .upload-file .upload-image {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
}
.upload-file-list .upload-file .upload-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.upload-file-list .upload-file p {
  margin: 0;
  margin-left: 12px;
  overflow: hidden;
  font-size: 0.875rem;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-file-list .upload-file p .upload-file-weight {
  display: none;
  margin-left: 10px;
  color: var(--bsi-color-text-secondary);
}
.upload-file-list .upload-file button {
  margin-left: auto;
  padding: 0;
  border: 0;
  background: transparent;
}
.upload-file-list .upload-file button:hover {
  cursor: pointer;
}
.upload-file-list .upload-file button:hover svg {
  fill: var(--bsi-icon-primary);
}
.upload-file-list .progress {
  position: absolute;
  bottom: -4px;
  left: 36px;
  width: calc(100% - 45px);
  height: 4px;
  background-color: hsl(210, 3%, 85%);
  box-shadow: none;
}
.upload-file-list .progress.progress-image {
  width: calc(100% - 60px);
}

.upload-avatar-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.upload-avatar-container .upload-avatar[type=file] + label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.upload-avatar-container .upload-avatar[type=file] + label svg {
  display: none;
}
.upload-avatar-container .upload-avatar[type=file] + label span {
  display: none;
}

.avatar-upload {
  overflow: hidden;
}

.avatar-upload-wrapper {
  position: relative;
  display: inline-block;
}
.avatar-upload-wrapper .avatar-upload-icon {
  position: absolute;
  right: 4px;
  bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 2px solid var(--bsi-color-border-inverse);
  border-radius: 50%;
  background: hsl(210, 6.2290689886%, 92.535%);
  pointer-events: none;
  z-index: 1;
}
.avatar-upload-wrapper.size-sm .avatar {
  width: 80px;
  height: 80px;
}
.avatar-upload-wrapper.size-sm .avatar-upload-icon {
  right: 6px;
  bottom: 8px;
  width: 24px;
  height: 24px;
}

.upload-dragdrop {
  display: inline-flex;
  align-items: center;
}
.upload-dragdrop.dragover .upload-dragdrop-image img, .upload-dragdrop.loading .upload-dragdrop-image img {
  transform: translateX(-50%) translateY(-50%) scale(0.85);
}
.upload-dragdrop.loading p:not(.upload-dragdrop-weight) {
  font-style: italic;
}
.upload-dragdrop.loading .upload-dragdrop-loading {
  opacity: 1;
}
.upload-dragdrop.loading .upload-dragdrop-text .upload-dragdrop-weight, .upload-dragdrop.success .upload-dragdrop-text .upload-dragdrop-weight {
  visibility: visible;
}
.upload-dragdrop.success .upload-dragdrop-success {
  opacity: 1;
  transform: scale(1);
}

.upload-dragdrop-text p {
  margin: 0;
  color: var(--bsi-color-text-secondary);
  font-size: 0.875rem;
}
.upload-dragdrop-text p.upload-dragdrop-weight {
  visibility: hidden;
  color: var(--bsi-color-text-secondary);
  font-size: 0.75rem;
}
.upload-dragdrop-text p.upload-dragdrop-weight svg {
  fill: var(--bsi-icon-secondary);
}
.upload-dragdrop-text h5 {
  margin: 0;
  color: var(--bsi-color-text-base);
}

.upload-dragdrop-input {
  position: absolute;
  z-index: -1;
  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  opacity: 0;
}
.upload-dragdrop-input[type=file] + label {
  color: var(--bsi-color-text-primary);
  text-decoration: underline;
  cursor: pointer;
}
.upload-dragdrop-input:focus[type=file] + label {
  outline: auto 5px -webkit-focus-ring-color;
}

.upload-dragdrop-loading {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 128px;
  height: 128px;
  overflow: hidden;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.2s;
}
.upload-dragdrop-loading .progress-donut {
  position: relative;
}
.upload-dragdrop-loading .progress-donut .progressbar-text {
  color: #000 !important;
  font-weight: 700;
}
.upload-dragdrop-loading .progress-donut svg {
  position: relative;
}
.upload-dragdrop-loading .progress-donut svg path:first-child {
  display: none;
}
.upload-dragdrop-loading .progress-donut:before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 0;
  content: "";
  width: 67px;
  height: 67px;
  border-radius: 50%;
  background: #fff;
  transform: translateX(-50%) translateY(-50%);
}

.upload-dragdrop-image {
  position: relative;
  flex-shrink: 0;
  width: 128px;
  height: 128px;
  margin-right: var(--bsi-spacing-s);
}
.upload-dragdrop-image img {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 50%;
  transform: translateX(-50%) translateY(-50%);
  transform-origin: center center;
  transition: transform 0.4s cubic-bezier(0.33, 1.07, 0.54, 1);
}
.upload-dragdrop-image .upload-dragdrop-success {
  position: absolute;
  top: calc(50% - 18px);
  left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  opacity: 0;
  background: var(--bsi-color-background-success);
  transform: scale(0.6);
  transition: opacity 0.2s, transform 0.5s cubic-bezier(0.75, -0.5, 0, 1.75);
}
.upload-dragdrop-image .upload-dragdrop-success svg {
  width: 30px;
  height: 30px;
  fill: var(--bsi-icon-inverse);
}
.upload-dragdrop-image .upload-dragdrop-success .upload-dragdrop-text h5 + p {
  color: var(--bsi-color-text-success);
  font-weight: var(--bsi-font-weight-solid);
}

@media (min-width: 576px) {
  .upload[type=file] + label {
    font-size: var(--bsi-label-font-size-s);
  }
}
@media (min-width: 768px) {
  .upload-dragdrop-image {
    width: 180px;
    height: 180px;
    margin-right: 32px;
  }
  .upload-dragdrop-image .upload-dragdrop-success {
    left: 28px;
  }
  .upload-dragdrop-loading {
    width: 180px;
    height: 180px;
  }
  .upload-dragdrop-loading .progress-donut:before {
    content: "";
    width: 94px;
    height: 94px;
  }
}
@media (min-width: 1200px) {
  .avatar-upload:hover .upload-avatar-container,
  .avatar-upload:focus-within .upload-avatar-container {
    opacity: 1;
  }
  .upload-avatar-container {
    top: auto;
    right: 0;
    bottom: -10%;
    left: 0;
    width: 100%;
    height: 60%;
    opacity: 0;
    background-color: var(--bsi-overlay-background-primary-muted);
    transition: opacity var(--bsi-transition-instant);
  }
  .upload-avatar-container .upload-avatar[type=file] + label {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    margin: 0;
    padding-top: var(--bsi-spacing-xxs);
    color: var(--bsi-color-text-inverse);
    font-size: 0.75rem;
    text-align: center;
    cursor: pointer;
  }
  .upload-avatar-container .upload-avatar[type=file] + label span {
    display: block;
  }
  .upload-avatar-container .upload-avatar[type=file] + label svg {
    display: block;
    width: 20px;
    height: 20px;
    fill: var(--bsi-icon-inverse);
  }
  .upload-avatar-container .upload-avatar:focus:not([data-focus-mouse=true])[type=file] + label {
    outline: auto 5px -webkit-focus-ring-color;
  }
  .avatar-upload-wrapper .avatar-upload-icon {
    display: none;
  }
  .avatar-upload-wrapper.size-sm .upload-avatar[type=file] + label span {
    display: none;
  }
}
.form-feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
}

.input-group-text:has(~ [data-focus-mouse=true]:not(.btn)),
[data-focus-mouse=true]:not(.btn) ~ .input-group-text,
button:has(~ [data-focus-mouse=true]:not(.btn)),
[data-focus-mouse=true]:not(.btn) + button {
  border-color: inherit !important;
  box-shadow: none !important;
  outline: none !important;
}

.input-group-text:has(~ .is-invalid),
.is-invalid ~ .input-group-text,
button:has(~ .is-invalid),
.is-invalid + button {
  border-color: var(--bsi-color-border-danger) !important;
}

.sr-only-justvalidate-bi {
  display: none;
}

.is-valid,
.is-invalid {
  padding-right: calc(1.5em + 0.75rem) !important;
}
.is-valid[type=number],
.is-invalid[type=number] {
  padding-right: calc(1.5em + 0.75rem + var(--bsi-form-control-spacing) + 1rem) !important;
}

.was-validated &:valid,
.is-valid {
  border-color: var(--bsi-color-border-success) !important;
  background-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="%23008055" xmlns="http://www.w3.org/2000/svg"><path d="M9.6,16.9L4,11.4l0.8-0.7l4.8,4.8l8.5-8.4l0.7,0.7L9.6,16.9z" /></svg>');
}
.was-validated &:valid ~ .warning-feedback,
.is-valid ~ .warning-feedback {
  display: block;
}

.was-validated &:invalid,
.is-invalid {
  border-color: var(--bsi-color-border-danger) !important;
  background-image: url('data:image/svg+xml,<svg width="24" fill="%23cc334d" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.7,12l6.7,6.6l-0.8,0.8L12,12.7l-6.6,6.7l-0.8-0.8l6.7-6.6L4.6,5.4l0.8-0.8l6.6,6.7l6.6-6.7l0.8,0.8L12.7,12z" /></svg>');
}

.form-control.warning {
  border-color: var(--bsi-color-border-warning) !important;
  background-image: url('data:image/svg+xml,<svg width="24" height="24" fill="%23995c00" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.5,17h-1V2h1V17z M12.5,20h-1v2h1V20z" /></svg>');
}

.input-group-text:has(~ .is-valid),
.is-valid ~ .input-group-text,
button:has(~ .is-valid),
.is-valid + button {
  border-color: var(--bsi-color-border-success);
}

.is-valid + .input-group-text.align-buttons,
.is-invalid + .input-group-text.align-buttons {
  right: 30px;
}

.is-invalid + .input-group-text.align-buttons {
  bottom: 22px;
}

.autocomplete__wrapper .form-feedback {
  position: absolute;
}

textarea.form-control {
  background-position: top 0.5em right !important;
}

body {
  font-family: var(--bsi-font-sans);
}

p,
ul,
ol,
dl {
  font-size: var(--bsi-body-font-size);
  line-height: var(--bsi-body-leading);
}

caption,
figcaption {
  font-size: var(--bsi-caption-font-size);
  line-height: var(--bsi-caption-leading);
}

b,
strong {
  font-weight: var(--bsi-font-weight-strong);
}

mark,
code {
  padding: 0 var(--bsi-spacing-3xs);
}

mark {
  background-color: var(--bsi-highlight-background);
}

pre,
code,
kbd,
samp {
  border-radius: var(--bsi-radius-smooth);
  font-family: var(--bsi-font-mono);
}

ins,
del {
  position: relative;
  display: flex;
  align-items: center;
  padding: var(--bsi-spacing-3xs) var(--bsi-spacing-m);
  font: var(--bsi-body-font-size);
  text-decoration: none;
}

ins {
  background-color: var(--bsi-ins-background);
  text-decoration: none;
}

del {
  background-color: var(--bsi-del-background);
}

del::before,
ins::before {
  position: absolute;
  left: 0.5rem;
}

del::before {
  content: "−";
}

ins::before {
  content: "+";
}

kbd {
  margin: 0 2px;
  padding: 2px var(--bsi-spacing-3xs);
  border: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  background-color: var(--bsi-color-background-secondary-lighter);
  box-shadow: var(--bsi-elevation-low), 0 2px 0 0 hsla(255, 0%, 100%, 0.7) inset;
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-font-size-1);
  font-weight: var(--bsi-font-weight-solid);
  white-space: nowrap;
}
kbd kbd {
  padding: 0;
  font-size: var(--bsi-code-font-size);
}

small,
.small {
  font-size: var(--bsi-caption-font-size);
}

.x-small {
  font-size: var(--bsi-font-size-1);
}

h1,
.h1 {
  font-size: var(--bsi-heading-1-font-size);
}

h2,
.h2 {
  font-size: var(--bsi-heading-2-font-size);
}

h3,
.h3 {
  font-size: var(--bsi-heading-3-font-size);
}

h4,
.h4 {
  font-size: var(--bsi-heading-4-font-size);
}

h5,
.h5 {
  font-size: var(--bsi-heading-5-font-size);
}

h6,
.h6 {
  font-size: var(--bsi-heading-6-font-size);
}

h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 0;
  margin-bottom: var(--bsi-heading-spacing);
  line-height: var(--bsi-heading-leading);
}
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h1, p + h1,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h1,
p + .h1,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h2,
p + h2,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h2,
p + .h2,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h3,
p + h3,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h3,
p + .h3,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h4,
p + h4,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h4,
p + .h4,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h5,
p + h5,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h5,
p + .h5,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h6,
p + h6,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h6,
p + .h6 {
  padding-top: var(--bsi-spacing-s);
}

h1,
h2,
h3,
.h1,
.h2,
.h3 {
  font-weight: var(--bsi-heading-font-weight);
}

h4,
h5,
h6,
.h4,
.h5,
.h6 {
  font-weight: var(--bsi-heading-font-weight-weak);
}

h1,
.h1,
.display-1 {
  letter-spacing: -1px;
}

.font-serif {
  font-family: var(--bsi-font-serif) !important;
}

.font-sans-serif {
  font-family: var(--bsi-font-sans) !important;
}

.font-monospace {
  font-family: var(--bsi-font-mono) !important;
}

.display-1 {
  font-size: var(--bsi-display-font-size);
  font-weight: var(--bsi-heading-font-weight);
  line-height: var(--bsi-heading-leading);
}

.lead {
  font-size: var(--bsi-lead-font-size);
  font-weight: var(--bsi-lead-font-weight);
  line-height: var(--bsi-lead-leading);
}

blockquote,
.blockquote {
  margin: var(--bsi-spacing-m) 0;
  margin-left: var(--bsi-spacin-inline-xs);
  padding: var(--bsi-spacing-s);
  border-left: var(--bsi-border-thick) solid var(--bsi-border-color-secondary);
  font-size: var(--bsi-body-font-size);
  line-height: var(--bsi-body-leading);
}
blockquote > :last-child,
.blockquote > :last-child {
  margin-bottom: 0;
}
blockquote.text-end,
.blockquote.text-end {
  margin-right: var(--bsi-spacin-inline-xs);
  border-right: var(--bsi-border-thick) solid var(--bsi-border-color-secondary);
}
blockquote.text-center, blockquote.text-end, blockquote.blockquote-simple,
.blockquote.text-center,
.blockquote.text-end,
.blockquote.blockquote-simple {
  margin-left: 0;
  border-right: none;
  border-left: none;
}
blockquote.text-center, blockquote.blockquote-simple,
.blockquote.text-center,
.blockquote.blockquote-simple {
  padding: 0;
}
blockquote.blockquote-simple,
.blockquote.blockquote-simple {
  font-style: italic;
}
blockquote.blockquote-card,
.blockquote.blockquote-card {
  margin-left: 0;
  padding: var(--bsi-spacing-m);
  background-color: var(--bsi-color-background-inverse);
  box-shadow: var(--bsi-elevation-low);
}
blockquote.blockquote-card .blockquote-footer,
.blockquote.blockquote-card .blockquote-footer {
  font-size: inherit;
}
blockquote.blockquote-card .blockquote-footer:before,
.blockquote.blockquote-card .blockquote-footer:before {
  content: none;
}
blockquote.blockquote-card.dark,
.blockquote.blockquote-card.dark {
  border-left: none;
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
}
blockquote.blockquote-card.dark .blockquote-footer,
.blockquote.blockquote-card.dark .blockquote-footer {
  color: var(--bsi-color-text-inverse);
}

.blockquote-footer {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-label-font-size);
}
.blockquote-footer::before {
  content: "— ";
}
.bg-dark .blockquote-footer {
  color: var(--bsi-color-text-muted);
}

.initialism {
  font-size: var(--bsi-label-font-size-s);
  text-transform: uppercase;
}

.d-none {
  display: none !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-flex {
  display: flex !important;
}

.m-0 {
  margin: 0 !important;
}

.text-primary {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-primary-rgb), var(--bsi-text-opacity)) !important;
}

.text-secondary {
  --bsi-text-opacity: 1;
  color: hsl(210, 33%, 28%) !important;
}

.text-success {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-success-rgb), var(--bsi-text-opacity)) !important;
}

.text-info {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-info-rgb), var(--bsi-text-opacity)) !important;
}

.text-warning {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-warning-rgb), var(--bsi-text-opacity)) !important;
}

.text-danger {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-danger-rgb), var(--bsi-text-opacity)) !important;
}

.text-light {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-light-rgb), var(--bsi-text-opacity)) !important;
}

.text-dark {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-dark-rgb), var(--bsi-text-opacity)) !important;
}

.text-black {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-black-rgb), var(--bsi-text-opacity)) !important;
}

.text-white {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-white-rgb), var(--bsi-text-opacity)) !important;
}

.text-100 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-100-rgb), var(--bsi-text-opacity)) !important;
}

.text-200 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-200-rgb), var(--bsi-text-opacity)) !important;
}

.text-300 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-300-rgb), var(--bsi-text-opacity)) !important;
}

.text-400 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-400-rgb), var(--bsi-text-opacity)) !important;
}

.text-500 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-500-rgb), var(--bsi-text-opacity)) !important;
}

.text-600 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-600-rgb), var(--bsi-text-opacity)) !important;
}

.text-700 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-700-rgb), var(--bsi-text-opacity)) !important;
}

.text-800 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-800-rgb), var(--bsi-text-opacity)) !important;
}

.text-900 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-900-rgb), var(--bsi-text-opacity)) !important;
}

.text-body {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-body-color-rgb), var(--bsi-text-opacity)) !important;
}

.text-muted {
  --bsi-text-opacity: 1;
  color: hsl(210, 17%, 44%) !important;
}

.text-black-50 {
  --bsi-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bsi-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  --bsi-text-opacity: 1;
  color: inherit !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
}
@media (min-width: 1400px) {
  .d-xxl-none {
    display: none !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-flex {
    display: flex !important;
  }
}
label:has(.upload[type=file]) {
  display: flex;
  overflow: hidden;
  width: fit-content;
  max-width: unset !important;
  align-items: center;
  padding: var(--bsi-spacing-xs) var(--bsi-spacing-m);
  border-radius: var(--bsi-form-control-border-radius);
  margin-bottom: 0;
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
  cursor: pointer;
  font-size: 1rem;
  font-weight: 700;
  gap: var(--bsi-spacing-xxs, 8px);
  transition: background-color var(--bsi-transition-instant);
}
label:has(.upload[type=file]):hover {
  background-color: var(--bsi-color-background-primary-hover);
}

@media (min-width: 576px) {
  label:has(.upload[type=file]) {
    font-size: var(--bsi-label-font-size-s);
  }
}
:host([required]) .upload-required-feedback {
  display: block;
}

.upload-file it-progress {
  position: absolute;
  bottom: -4px;
  left: 36px;
  width: calc(100% - 45px);
}

.upload-file-list-image .upload-file it-progress {
  left: 52px;
  width: calc(100% - 60px);
}

:focus-visible,
label:has(.upload[type=file]:focus-visible),
.upload-dragdrop-input:focus-visible[type=file] + label,
.avatar-upload:focus-within:focus-visible {
  border-color: #000 !important;
  box-shadow: 0 0 0 2px hsl(0, 0%, 100%), 0 0 0 5px hsl(0, 0%, 0%) !important;
  outline: 3px solid rgba(0, 0, 0, 0) !important;
  outline-offset: 3px !important;
}

.upload[type=file]:focus-visible {
  border-color: initial !important;
  box-shadow: none !important;
  outline: none !important;
  outline-offset: initial !important;
}

.upload-file-actions {
  display: flex;
  align-items: center;
  padding-left: var(--bsi-spacing-xs, 12px);
  margin-left: auto;
  gap: calc(var(--bsi-spacing-xxs, 8px) / 2);
}
.upload-file-actions .upload-file-success {
  margin-bottom: calc(var(--bsi-spacing-xxs, 8px) / 2);
}

.upload-image {
  position: relative;
}
.upload-image .upload-image-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 50%;
  line-height: 1;
}

.upload-pictures-wall label:has(.upload[type=file]) {
  display: flex;
  width: 128px;
  height: 128px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 2px dashed var(--bsi-color-border-primary);
  border-radius: 0;
  background-color: var(--bsi-color-border-primary-lighter);
  color: var(--bsi-color-text-primary);
  font-weight: 600;
  transition: border-color var(--bsi-transition-instant);
}
.upload-pictures-wall label:has(.upload[type=file]):hover {
  border: 2px dashed var(--bsi-color-border-primary-hover);
}`;

registerTranslation(translation);
registerTranslation(translation$1);
let ItUpload = class ItUpload extends FormControl {
    constructor() {
        super(...arguments);
        // Override the base FormControlController to submit File[] instead of strings.
        // The base class field is declared as `protected readonly` but re-declaring here
        // shadows it cleanly via class field initialization order.
        this.formControlController = new FormControlController(this, {
            value: (el) => el._files.map((f) => f._raw),
            assumeInteractionOn: ['it-change'],
        });
        /** Allow multiple file selection */
        this.multiple = false;
        /** Show image thumbnails in the file list */
        this.imagePreview = false;
        /** Layout variant: 'default' shows a vertical file list, 'gallery' shows a pictures-wall grid */
        this.variant = 'default';
        /** Support text displayed below the upload button */
        this.supportText = '';
        /**
         * If true, files transition to 'success' automatically as soon as they are added
         * (useful for purely client-side scenarios).
         * Leave false (default) when you need to call setFileStatus() after a real HTTP upload.
         */
        this.autoSuccess = false;
        this._files = [];
    }
    get label() {
        if (this.labelElements.length > 0) {
            return this.labelElements[0].innerText.trim();
        }
        return '';
    }
    /** Returns a copy of the current file list */
    get files() {
        return this._files.map(({ _raw: _, ...rest }) => rest);
    }
    /**
     * Programmatically add a file to the list with an initial status of 'loading'.
     * Returns the generated id for use with setFileStatus / removeFile.
     */
    addFile(file) {
        const id = `upload-file-${Math.random().toString(36).slice(2)}`;
        const entry = {
            id,
            name: file.name,
            size: file.size,
            status: 'loading',
            _raw: file,
        };
        this._files = [...this._files, entry];
        return id;
    }
    /** Update the status (and optional progress 0–100) of a file by id. No-op for unknown ids. */
    setFileStatus(id, status, progress) {
        this._files = this._files.map((f) => (f.id === id ? { ...f, status, progress: progress ?? f.progress } : f));
    }
    /** Set a thumbnail data URL for a file entry by id. No-op for unknown ids. */
    setFileThumbnail(id, dataUrl) {
        this._files = this._files.map((f) => (f.id === id ? { ...f, thumbnail: dataUrl } : f));
    }
    /** Remove a file entry by id. No-op for unknown ids. */
    removeFile(id) {
        this._files = this._files.filter((f) => f.id !== id);
        this._validateFiles();
    }
    connectedCallback() {
        super.connectedCallback?.();
        this._handleReady();
    }
    updated(changedProperties) {
        super.updated?.(changedProperties);
        if (!this.label && this.label?.length === 0) {
            this.logger.warn(`Label is required for accessibility. Define a <span slot="label"> inside <it-upload name="${this.name}">.`);
        }
    }
    // Override FormControl.checkValidity — the native hidden input manages required state
    checkValidity() {
        return this.inputElement?.checkValidity() ?? true;
    }
    /** Override to prevent string-level validation messages from FormControl base */
    handleValidationMessages() {
        this._validateFiles();
    }
    _validateFiles() {
        if (!this.customValidation) {
            if (this.required && this._files.length === 0) {
                this.inputElement?.setCustomValidity(this.$t('validityRequired'));
                this.validationMessage = this.$t('validityRequired');
            }
            else {
                this.inputElement?.setCustomValidity('');
                this.validationMessage = '';
            }
        }
        this.formControlController.updateValidity();
    }
    get validity() {
        return this.inputElement?.validity;
    }
    _handleFileChange(e) {
        const input = e.target;
        const fileList = input.files;
        if (!fileList || fileList.length === 0)
            return;
        const newFiles = Array.from(fileList);
        newFiles.forEach((file) => {
            const id = this.addFile(file);
            if (file.type.startsWith('image/') && (this.imagePreview || this.variant === 'gallery')) {
                const reader = new FileReader();
                reader.onload = (ev) => {
                    this.setFileThumbnail(id, ev.target?.result);
                    if (this.autoSuccess)
                        this.setFileStatus(id, 'success');
                };
                reader.readAsDataURL(file);
            }
            else if (this.autoSuccess) {
                this.setFileStatus(id, 'success');
            }
        });
        // Reset the native input so the same file can be re-selected
        input.value = '';
        this._validateFiles();
        this.dispatchEvent(new CustomEvent('it-upload-add', {
            detail: { files: newFiles, name: this.name, id: this.id },
            bubbles: true,
            composed: true,
        }));
        this.dispatchEvent(new CustomEvent('it-change', {
            detail: { files: this._files.map((f) => f._raw), name: this.name, id: this.id },
            bubbles: true,
            composed: true,
        }));
    }
    _handleRemove(id, name) {
        this.removeFile(id);
        this.dispatchEvent(new CustomEvent('it-upload-remove', {
            detail: { id, name, componentName: this.name, componentId: this.id },
            bubbles: true,
            composed: true,
        }));
        this.dispatchEvent(new CustomEvent('it-change', {
            detail: { files: this._files.map((f) => f._raw), name: this.name, id: this.id },
            bubbles: true,
            composed: true,
        }));
    }
    _getStatusLabel(status) {
        switch (status) {
            case 'loading':
                return this.$t('upload_status_loading');
            case 'success':
                return this.$t('upload_status_success');
            case 'error':
            default:
                return this.$t('upload_status_error');
        }
    }
    _getRemoveLabel(f) {
        let key;
        switch (f.status) {
            case 'loading':
                key = 'upload_remove_loading';
                break;
            case 'error':
                key = 'upload_remove_error';
                break;
            case 'success':
            default:
                key = 'upload_remove_done';
                break;
        }
        const template = this.$t(key);
        return template.replace('{name}', f.name);
    }
    // eslint-disable-next-line class-methods-use-this
    _iconForStatus(status) {
        switch (status) {
            case 'loading':
            case 'success':
                return 'it-file';
            case 'error':
            default:
                return 'it-close-circle';
        }
    }
    // eslint-disable-next-line class-methods-use-this
    _colorForStatus(status) {
        switch (status) {
            case 'success':
                return 'success';
            case 'error':
                return 'danger';
            default:
                return 'secondary';
        }
    }
    // eslint-disable-next-line class-methods-use-this
    _actionIconForStatus(status) {
        return status === 'success' ? 'it-check' : 'it-close';
    }
    _renderFileItem(f) {
        const liClass = this.composeClass('upload-file', f.status === 'loading' ? 'uploading' : f.status);
        const statusLabel = this._getStatusLabel(f.status);
        const removeLabel = this._getRemoveLabel(f);
        return html `
      <li class="${liClass}" role="listitem">
        ${when(this.imagePreview && f.thumbnail, () => html `
            <div class="upload-image">
              <img src="${f.thumbnail}" alt="${f.name}" />
            </div>
          `, () => html `<it-icon
              name="${this._iconForStatus(f.status)}"
              size="sm"
              color="${this._colorForStatus(f.status)}"
              aria-hidden="true"
            ></it-icon>`)}
        <p>
          <span class="visually-hidden">${statusLabel}</span>${f.name}${when(f.status === 'success', () => html `<span class="upload-file-weight">${formatSize(f.size)}</span>`)}
        </p>

        ${when(f.status === 'success', () => html `
            <div class="upload-file-actions" part="file-status-indicator">
              <it-icon
                name="it-check"
                size="xs"
                color="success"
                aria-hidden="true"
                class="upload-file-success"
              ></it-icon>
              <button
                part="file-remove-button"
                type="button"
                @click="${() => this._handleRemove(f.id, f.name)}"
                ?disabled="${this.disabled}"
              >
                <span class="visually-hidden">${removeLabel}</span>
                <it-icon name="it-close" aria-hidden="true" color="secondary"></it-icon>
              </button>
            </div>
          `, () => html `
            <button
              part="file-remove-button"
              type="button"
              @click="${() => this._handleRemove(f.id, f.name)}"
              ?disabled="${this.disabled}"
            >
              <span class="visually-hidden">${removeLabel}</span>
              <it-icon
                name="${this._actionIconForStatus(f.status)}"
                color="${this._colorForStatus(f.status)}"
                aria-hidden="true"
              ></it-icon>
            </button>
          `)}
        ${when(f.status === 'loading', () => html ` <it-progress type="line" .value="${f.progress ?? 0}" it-aria-label="${f.name}"></it-progress> `)}
      </li>
    `;
    }
    _renderGalleryItem(f) {
        // NOTE: BSI reference HTML does not include a remove button for gallery items.
        // Added here as a critical accessibility addition: without it there is no way
        // to remove a photo once added (WCAG 2.1 SC 3.3.4 Error Prevention).
        const removeLabel = this._getRemoveLabel(f);
        return html `
      <li class="upload-image" role="listitem">
        ${when(f.thumbnail, () => html `<img src="${f.thumbnail}" alt="${f.name}" />`)}
        <button
          part="gallery-remove-button"
          type="button"
          class="btn btn-primary btn-icon btn-xs upload-image-remove"
          @click="${() => this._handleRemove(f.id, f.name)}"
          ?disabled="${this.disabled}"
        >
          <span class="visually-hidden">${removeLabel}</span>
          <it-icon name="it-close" size="xs" color="inverse" aria-hidden="true"></it-icon>
        </button>
      </li>
    `;
    }
    _renderFileList() {
        if (this._files.length === 0)
            return nothing;
        if (this.variant === 'gallery') {
            return html ` ${this._files.map((f) => this._renderGalleryItem(f))} `;
        }
        const listClass = this.composeClass('upload-file-list', this.imagePreview ? 'upload-file-list-image' : '');
        return html `
      <ul class="${listClass}" aria-label="${this.$t('upload_file_list_label')}" role="list">
        ${this._files.map((f) => this._renderFileItem(f))}
      </ul>
    `;
    }
    _renderUploadInput() {
        const inputId = this._id;
        const labelText = this.variant === 'gallery' ? this.$t('upload_gallery_label') : this.$t('upload_label');
        const showValidation = this.formControlController.submittedOnce || this.customValidation;
        const isInvalid = showValidation && this.validationMessage.length > 0;
        return html `
      <div class="form-group">
        <!-- Wrapping pattern per Scott O'Hara "Styled File Uploads":
             https://scottaohara.github.io/a11y_styled_form_controls/src/file-upload/
             Input inside label instead of BSI's sibling pattern (0.1px ghost input +
             styled adjacent label). BSI's pattern makes VoiceOver visit the ghost as a
             confusing "small square group" before the real button. With wrapping, both
             stops are logical: label text → file upload control. No JS needed — click
             propagation to the file picker is handled natively by the label. -->
        <label part="input-label" for="${inputId}">
          <slot name="icon">
            <it-icon
              name="${this.variant === 'gallery' ? 'it-plus' : 'it-upload'}"
              size="${this.variant === 'gallery' ? 'lg' : 'sm'}"
              aria-hidden="true"
              color="${this.variant === 'gallery' ? 'primary' : 'inverse'}"
            ></it-icon>
          </slot>
          <slot name="label">${labelText}</slot>
          <input
            type="file"
            class="upload it-form__control"
            id="${inputId}"
            name="${this.name}"
            ?multiple="${this.multiple}"
            accept="${ifDefined(this.accept)}"
            ?disabled="${this.disabled}"
            ?required="${this.required && this._files.length === 0}"
            ?formNoValidate="${this.customValidation}"
            aria-invalid="${isInvalid ? 'true' : nothing}"
            aria-describedby="${ifDefined(isInvalid ? `invalid-feedback-${inputId}` : undefined)}"
            @change="${this._handleFileChange}"
          />
        </label>

        ${when(this.supportText, () => html `<small class="form-text">${this.supportText}</small>`)}

        <div role="alert" id="invalid-feedback-${inputId}" class="form-feedback text-danger" ?hidden=${!isInvalid}>
          ${isInvalid ? html `<span class="visually-hidden">${this.label}: </span>${this.validationMessage}` : nothing}
        </div>
      </div>
    `;
    }
    render() {
        if (this.variant === 'gallery') {
            return html `
        <ul class="upload-pictures-wall" role="list">
          ${this._renderFileList()}
          <li>${this._renderUploadInput()}</li>
        </ul>
      `;
        }
        return html ` ${this._renderUploadInput()} ${this._renderFileList()} `;
    }
};
ItUpload.styles = styles;
__decorate([
    query('.it-form__control'),
    __metadata("design:type", HTMLInputElement)
], ItUpload.prototype, "inputElement", void 0);
__decorate([
    queryAssignedElements({ slot: 'label' }),
    __metadata("design:type", Array)
], ItUpload.prototype, "labelElements", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItUpload.prototype, "multiple", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], ItUpload.prototype, "accept", void 0);
__decorate([
    property({ type: Boolean, attribute: 'image-preview' }),
    __metadata("design:type", Object)
], ItUpload.prototype, "imagePreview", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", String)
], ItUpload.prototype, "variant", void 0);
__decorate([
    property({ type: String, attribute: 'support-text' }),
    __metadata("design:type", Object)
], ItUpload.prototype, "supportText", void 0);
__decorate([
    property({ type: Boolean, attribute: 'auto-success' }),
    __metadata("design:type", Object)
], ItUpload.prototype, "autoSuccess", void 0);
__decorate([
    state(),
    __metadata("design:type", Array)
], ItUpload.prototype, "_files", void 0);
ItUpload = __decorate([
    customElement('it-upload')
], ItUpload);

export { ItUpload };
//# sourceMappingURL=it-upload.js.map
